'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { nanoid } from 'nanoid';
import { Checkbox } from '../Checkbox/Checkbox.js';
export const InlineCheckbox = (_a) => {
    var { className, checked, id, indeterminate = false, name = '', label, ariaDescribedBy, disabled, readOnly, onChange, value = '', hideLabel } = _a, other = __rest(_a, ["className", "checked", "id", "indeterminate", "name", "label", "ariaDescribedBy", "disabled", "readOnly", "onChange", "value", "hideLabel"]);
    const ref = React.useRef(null);
    const [checkedState, setCheckedState] = React.useState(checked ? checked : false);
    const [indeterminateState, setIndeterminateState] = React.useState(indeterminate ? indeterminate : false);
    const [idVar, setId] = React.useState('');
    React.useEffect(() => {
        if (checkedState) {
            setIndeterminateState(false);
        }
        else {
            setIndeterminateState(indeterminate);
        }
        setId(id || nanoid());
    }, [id, checked, checkedState, indeterminate]);
    function handleOnChange(checked) {
        if (onChange) {
            onChange(checked);
        }
        setCheckedState(!checkedState);
        if (indeterminateState) {
            setIndeterminateState(false);
            setCheckedState(false);
        }
    }
    const componentClassName = classnames('sparky-c-inline-checkbox', className, {
        'sparky-c-inline-checkbox--hide-label': hideLabel,
    });
    return (_jsxs("label", Object.assign({ className: componentClassName, htmlFor: idVar, ref: ref }, other, { children: [_jsx(Checkbox, { className: "sparky-c-inline-checkbox__control", id: idVar, disabled: disabled, ariaDescribedBy: ariaDescribedBy, readOnly: readOnly, name: name, indeterminate: indeterminateState, checked: checkedState, value: value, onChange: (checked) => handleOnChange(checked) }), _jsx("div", Object.assign({ className: hideLabel
                    ? 'sparky-c-inline-checkbox__text sparky-u-is-vishidden'
                    : 'sparky-c-inline-checkbox__text' }, { children: label }))] })));
};
//# sourceMappingURL=InlineCheckbox.js.map